/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DescriptionInputs */

const th_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายละเอียด`)
};

const en_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const ja_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明`)
};

const zh_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简介`)
};

const es_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción`)
};

const pt_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição`)
};

const id_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deskripsi`)
};

const fr_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const tl_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paglalarawan`)
};

const vi_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả`)
};

const ko_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설명`)
};

const de_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

const ru_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание`)
};

const tr_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Açıklama`)
};

const it_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione`)
};

const pl_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opis`)
};

const uk_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опис`)
};

const hi_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण`)
};

const ar_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصف`)
};

const ms_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keterangan`)
};

const bn_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিবরণ`)
};

const zh_tw2_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`說明`)
};

const zh_hk2_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`說明`)
};

const ur_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفصیل`)
};

const fa_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توضیح`)
};

const sw_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maelezo`)
};

const nl_description = /** @type {(inputs: DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omschrijving`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {DescriptionInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const description = /** @type {((inputs?: DescriptionInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DescriptionInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_description(inputs)
	if (locale === "ja") return ja_description(inputs)
	if (locale === "zh") return zh_description(inputs)
	if (locale === "es") return es_description(inputs)
	if (locale === "pt") return pt_description(inputs)
	if (locale === "id") return id_description(inputs)
	if (locale === "fr") return fr_description(inputs)
	if (locale === "tl") return tl_description(inputs)
	if (locale === "vi") return vi_description(inputs)
	if (locale === "ko") return ko_description(inputs)
	if (locale === "de") return de_description(inputs)
	if (locale === "ru") return ru_description(inputs)
	if (locale === "tr") return tr_description(inputs)
	if (locale === "it") return it_description(inputs)
	if (locale === "pl") return pl_description(inputs)
	if (locale === "uk") return uk_description(inputs)
	if (locale === "hi") return hi_description(inputs)
	if (locale === "ar") return ar_description(inputs)
	if (locale === "ms") return ms_description(inputs)
	if (locale === "bn") return bn_description(inputs)
	if (locale === "zh-TW") return zh_tw2_description(inputs)
	if (locale === "zh-HK") return zh_hk2_description(inputs)
	if (locale === "ur") return ur_description(inputs)
	if (locale === "fa") return fa_description(inputs)
	if (locale === "sw") return sw_description(inputs)
	if (locale === "nl") return nl_description(inputs)
	return en_description(inputs)
});